module.exports = __webpack_public_path__ + "public/images/curated-tutoring-frame.b9cd1522f6798def20ca0dd542f7add8.png";